import React from "react";
import SegmentedTabs from "./SegmentedTabs";

/**
 * Shared competition switcher shell (Predictions / Fixtures / Leaderboard).
 */
export default function CompetitionFilterBar({ items, activeKey, onChange, children }) {
  return (
    <div className="w-full space-y-3">
      <SegmentedTabs items={items} activeKey={activeKey} onChange={onChange} />
      {children}
    </div>
  );
}
